import { useMutation, UseMutationConfig } from '@libs/use';

import * as API from '../requests';

type UseRemoveSymbolFromWatchlistConfigs = {
  onReject?: UseMutationConfig<any>['onReject'];
  onSettled?: UseMutationConfig<any>['onSettled'];
  onSuccess?: UseMutationConfig<any>['onSuccess'];
};

export default function useRemoveSymbolFromWatchlist({
  onSuccess,
  onSettled,
  onReject,
}: UseRemoveSymbolFromWatchlistConfigs = {}) {
  const {
    execute: removeSymbolFromWatchlist,
    isPending: isRemovingWatchlistSymbol,
  } = useMutation(API.removeSymbolFromWatchlist, {
    onSuccess,
    onSettled,
    onReject,
  });

  return { removeSymbolFromWatchlist, isRemovingWatchlistSymbol };
}
